import { PDFDocument } from 'pdf-lib';

export const buildProfitAndLossSignatureSectionHtml = (signatureDataUrl) => `
<div class="signature-section" style="margin-top: 40px; padding: 20px; page-break-inside: avoid; direction: rtl;">
  <div style="border-top: 2px solid #333; padding-top: 20px;">
    <div style="display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 20px; direction: rtl;">
      <div style="flex: 1; min-width: 200px;">
        <div style="text-align: center; margin-bottom: 10px;">
          <img src="${signatureDataUrl}" alt="Signature" style="max-width: 300px; max-height: 100px; border: 1px solid #e0e0e0; padding: 5px; background: white;" />
        </div>
        <div style="border-top: 2px solid #000; padding-top: 5px; text-align: center;">
          <strong>חתימה מורשית</strong>
        </div>
      </div>
      <div style="flex: 1; min-width: 200px; text-align: center;">
        <div style="margin-bottom: 10px;">
          ${new Date().toLocaleDateString('he-IL', { year: 'numeric', month: 'long', day: 'numeric' })}
        </div>
        <div style="border-top: 2px solid #000; padding-top: 5px;">
          <strong>תאריך</strong>
        </div>
      </div>
    </div>
  </div>
</div>`;

export const injectSignatureIntoHtml = (html, signatureDataUrl) => {
  const signatureSection = buildProfitAndLossSignatureSectionHtml(signatureDataUrl);
  let htmlWithSignature = html || '';

  if (htmlWithSignature.includes('</div>\n      </body>')) {
    return htmlWithSignature.replace(
      '</div>\n      </body>',
      `${signatureSection}\n</div>\n      </body>`
    );
  }
  if (htmlWithSignature.includes('</div></body>')) {
    return htmlWithSignature.replace(
      '</div></body>',
      `${signatureSection}\n</div></body>`
    );
  }
  if (htmlWithSignature.includes('</body>')) {
    return htmlWithSignature.replace('</body>', `${signatureSection}\n</body>`);
  }
  return `${htmlWithSignature}${signatureSection}`;
};

export const triggerBlobDownload = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Append a signature+date page (HTML→PDF) to an existing report PDF.
 */
export const mergeReportPdfWithSignature = async ({
  reportPdfBlob,
  signatureDataUrl,
  caseId,
  token,
  convertHtmlToPdf,
}) => {
  const signatureHtml = `<!DOCTYPE html>
<html lang="he" dir="rtl">
<head>
  <meta charset="utf-8" />
  <style>
    body { font-family: Arial, Helvetica, sans-serif; margin: 40px; direction: rtl; }
  </style>
</head>
<body>
  ${buildProfitAndLossSignatureSectionHtml(signatureDataUrl)}
</body>
</html>`;

  const { blob: signaturePdfBlob } = await convertHtmlToPdf(caseId, signatureHtml, token);
  const mainDoc = await PDFDocument.load(await reportPdfBlob.arrayBuffer());
  const signatureDoc = await PDFDocument.load(await signaturePdfBlob.arrayBuffer());
  const copiedPages = await mainDoc.copyPages(signatureDoc, signatureDoc.getPageIndices());
  copiedPages.forEach((page) => mainDoc.addPage(page));
  const mergedBytes = await mainDoc.save();
  return new Blob([mergedBytes], { type: 'application/pdf' });
};
